export default __webpack_public_path__ + "static/media/lbapps.14fa65f4.svg";